var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReRegister({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10767",
    "data-name": "Group 10767",
    transform: "translate(-911 -1194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10750",
    "data-name": "Group 10750",
    transform: "translate(-431 105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_House_contract_-_Flaticon-2",
    "data-name": "Search results for House contract - Flaticon-2",
    transform: "translate(1368 1105.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10518",
    "data-name": "Group 10518",
    transform: "translate(5.279 26.392)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10517",
    "data-name": "Group 10517"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10127",
    "data-name": "Path 10127",
    d: "M140.416,229.528H106.871a.858.858,0,1,0,0,1.709h33.545a.858.858,0,0,0,0-1.709Z",
    transform: "translate(-105.939 -229.525)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10520",
    "data-name": "Group 10520",
    transform: "translate(5.938 35.628)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10519",
    "data-name": "Group 10519",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10128",
    "data-name": "Path 10128",
    d: "M139.171,304.718H107.783a2.478,2.478,0,0,0-1.591.4.528.528,0,0,0,0,.9,2.478,2.478,0,0,0,1.591.4h31.388c.875-.039,1.546-.41,1.546-.854S140.046,304.757,139.171,304.718Z",
    transform: "translate(-105.939 -304.715)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10522",
    "data-name": "Group 10522",
    transform: "translate(5.278 52.781)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10521",
    "data-name": "Group 10521",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10129",
    "data-name": "Path 10129",
    d: "M139.867,455.1H107.476c-.741.039-1.309.41-1.309.854s.568.815,1.309.854h32.39c.741-.039,1.309-.41,1.309-.854s-.568-.815-1.309-.854Z",
    transform: "translate(-106.167 -455.1)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10522-2",
    "data-name": "Group 10522",
    transform: "translate(5.278 44.204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10521-2",
    "data-name": "Group 10521",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10129-2",
    "data-name": "Path 10129",
    d: "M139.867,455.1H107.476c-.741.039-1.309.41-1.309.854s.568.815,1.309.854h32.39c.741-.039,1.309-.41,1.309-.854s-.568-.815-1.309-.854Z",
    transform: "translate(-106.167 -455.1)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10524",
    "data-name": "Group 10524",
    transform: "translate(5.266 5.234)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10523",
    "data-name": "Group 10523"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10130",
    "data-name": "Path 10130",
    d: "M120.058,51.621l-7.146-6.71a.858.858,0,0,0-1.17,0l-7.145,6.71a.858.858,0,1,0,1.17,1.246l6.56-6.162,6.56,6.162a.855.855,0,1,0,1.171-1.246Z",
    transform: "translate(-104.269 -44.68)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10526",
    "data-name": "Group 10526",
    transform: "translate(7.532 8.789)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10525",
    "data-name": "Group 10525"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10131",
    "data-name": "Path 10131",
    d: "M134.362,79.484l-4.374-4.108a1.415,1.415,0,0,0-1.934,0l-4.374,4.108a1.417,1.417,0,0,0-.446,1.03V86.49a1.414,1.414,0,0,0,1.413,1.413h8.747a1.414,1.414,0,0,0,1.413-1.413V80.513a1.418,1.418,0,0,0-.445-1.029Zm-4.714,6.71h-1.254V83.232h1.254Zm3.451,0h-1.742v-3.5a1.169,1.169,0,0,0-1.168-1.168h-2.336a1.168,1.168,0,0,0-1.167,1.168v3.5h-1.742V80.641h0l4.074-3.83,4.077,3.83Z",
    transform: "translate(-123.234 -74.994)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10528",
    "data-name": "Group 10528",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10527",
    "data-name": "Group 10527"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10132",
    "data-name": "Path 10132",
    d: "M104.283,24.093a.853.853,0,0,0-.857.848V57.635a.066.066,0,0,1-.066.065H60.724a.066.066,0,0,1-.066-.065V1.759a.066.066,0,0,1,.066-.065H89.793V13.4a1.8,1.8,0,0,0,1.8,1.786h11.828v4.438a.858.858,0,0,0,1.708,0V14.284a.837.837,0,0,0-.013-.107h0a.835.835,0,0,0-.029-.105.077.077,0,0,0-.009-.026.838.838,0,0,0-.043-.1v-.005a.85.85,0,0,0-.059-.093l-.016-.022a.84.84,0,0,0-.075-.085L91.251.25a.846.846,0,0,0-.086-.073L91.141.16A.867.867,0,0,0,91.048.1h-.006a.855.855,0,0,0-.1-.042l-.027-.01a.859.859,0,0,0-.105-.029h0a.874.874,0,0,0-.1-.013H60.724A1.767,1.767,0,0,0,58.95,1.764V57.633a1.767,1.767,0,0,0,1.774,1.755H103.36a1.767,1.767,0,0,0,1.774-1.755V24.938a.853.853,0,0,0-.851-.846ZM91.5,2.889l10.72,10.61H91.6a.1.1,0,0,1-.1-.1Z",
    transform: "translate(-58.95 -0.009)",
    fill: "#00641f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10695",
    "data-name": "Group 10695",
    transform: "translate(1382.641 1127.133)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_118",
    "data-name": "Ellipse 118",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#00641f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.672,
    cy: 20.671,
    rx: 20.672,
    ry: 20.671,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.672,
    cy: 20.671,
    rx: 20.172,
    ry: 20.171,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10676",
    "data-name": "Group 10676",
    transform: "translate(8.05 24.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10541",
    "data-name": "Group 10541",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10108",
    "data-name": "Path 10108",
    d: "M13.263,394.906a1.834,1.834,0,0,0-1.478-2.919h-8.9A1.832,1.832,0,0,0,1.4,394.906,2.621,2.621,0,0,0,0,397.225v.524a.524.524,0,0,0,.524.524H14.142a.524.524,0,0,0,.524-.524v-.524A2.621,2.621,0,0,0,13.263,394.906ZM2.325,393.264a.78.78,0,0,1,.556-.23h8.9a.786.786,0,1,1,0,1.571h-8.9a.786.786,0,0,1-.556-1.341Zm-1.278,3.96a1.573,1.573,0,0,1,1.571-1.571h9.428a1.573,1.573,0,0,1,1.571,1.571Z",
    transform: "translate(0.195 -391.792)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10108_-_Outline",
    "data-name": "Path 10108 - Outline",
    d: "M2.826,391.737h8.9a2.03,2.03,0,0,1,1.754,3.049,2.808,2.808,0,0,1,1.322,2.384v.524a.72.72,0,0,1-.719.719H.469a.72.72,0,0,1-.719-.719v-.524a2.808,2.808,0,0,1,1.323-2.385,2.028,2.028,0,0,1,1.753-3.048Zm11.262,6.286a.329.329,0,0,0,.329-.329v-.524a2.421,2.421,0,0,0-1.3-2.146l-.2-.106.135-.183a1.622,1.622,0,0,0,.318-.97,1.64,1.64,0,0,0-1.638-1.638h-8.9a1.637,1.637,0,0,0-1.319,2.608l.135.183-.2.106a2.421,2.421,0,0,0-1.3,2.147v.524a.329.329,0,0,0,.329.329ZM2.826,392.785h8.9a.981.981,0,1,1,0,1.961h-8.9a.981.981,0,1,1,0-1.961Zm8.9,1.571a.591.591,0,1,0,0-1.181h-8.9a.591.591,0,1,0,0,1.181ZM2.564,395.4h9.428a1.768,1.768,0,0,1,1.766,1.766v.195H.8v-.195A1.768,1.768,0,0,1,2.564,395.4Zm10.791,1.571a1.378,1.378,0,0,0-1.363-1.181H2.564A1.378,1.378,0,0,0,1.2,396.975Z",
    transform: "translate(0.25 -391.737)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10677",
    "data-name": "Group 10677",
    transform: "translate(8.051 5.269)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10543",
    "data-name": "Group 10543",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10109",
    "data-name": "Path 10109",
    d: "M25.716,21.476a3.219,3.219,0,0,0-.616-.707l-2.388-2.083a.507.507,0,0,0-.2-.177l-1.444-1.26-6.686-5.832a1.531,1.531,0,0,0-.449-2.441l.619-.618a2.046,2.046,0,0,0,1.974-.528,2.044,2.044,0,0,0,0-2.892L12.185.6a2.044,2.044,0,0,0-3.42,1.974L2.594,8.745a2.057,2.057,0,0,0-.529-.069,2.044,2.044,0,0,0-1.446,3.49L4.956,16.5a2.044,2.044,0,0,0,3.42-1.974l.617-.617a1.534,1.534,0,0,0,2.442.448l7.121,8.181a.513.513,0,0,0,.069.087l.029.026,2.122,2.438c.053.062.109.123.168.182a3.04,3.04,0,0,0,2.161.9,3.137,3.137,0,0,0,.43-.03,3.093,3.093,0,0,0,2.282-1.58A3.024,3.024,0,0,0,25.716,21.476ZM10.016,1.323a1.022,1.022,0,0,1,1.446,0L15.8,5.66a1.022,1.022,0,0,1-1.445,1.446L10.016,2.769h0A1.023,1.023,0,0,1,10.016,1.323ZM7.125,15.78a1.024,1.024,0,0,1-1.446,0L1.342,11.443A1.022,1.022,0,0,1,2.787,10l4.338,4.338A1.023,1.023,0,0,1,7.125,15.78Zm2.152-3.6L7.848,13.612,3.51,9.274,9.293,3.491l4.338,4.337L12.2,9.261l-.014.014-2.89,2.89ZM11.1,13.249l0,0-.36.36a.511.511,0,0,1-.729-.717l2.9-2.9a.511.511,0,0,1,.867.367.506.506,0,0,1-.15.361l-.358.358-.007.007Zm1.059.387,1.494-1.494,6.325,5.517-2.308,2.308Zm6.184,7.1,2.408-2.408.772.674-2.507,2.507Zm6.58,3.323a2.079,2.079,0,0,1-1.53,1.067,2.031,2.031,0,0,1-1.728-.579c-.039-.039-.077-.08-.112-.122l0-.006-1.86-2.137L22.3,19.68l2.134,1.861,0,0a2.2,2.2,0,0,1,.422.485A2.018,2.018,0,0,1,24.925,24.063Z",
    transform: "translate(0.174 0.194)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10109_-_Outline",
    "data-name": "Path 10109 - Outline",
    d: "M23.053,26.312a3.229,3.229,0,0,1-2.3-.955c-.062-.062-.122-.127-.178-.194l-2.112-2.427-.028-.026a.7.7,0,0,1-.087-.106L11.36,14.572A1.724,1.724,0,0,1,9.1,14.414a1.734,1.734,0,0,1-.206-.248l-.367.367a2.245,2.245,0,0,1-.6,2.05,2.238,2.238,0,0,1-3.162,0L.425,12.245A2.236,2.236,0,0,1,2.476,8.478L8.5,2.456A2.245,2.245,0,0,1,9.1.406a2.235,2.235,0,0,1,3.162,0L16.6,4.745a2.235,2.235,0,0,1-2.05,3.766l-.368.368a1.724,1.724,0,0,1,.405,2.464L22.564,18.3a.7.7,0,0,1,.166.122.708.708,0,0,1,.073.086l2.372,2.068a3.406,3.406,0,0,1,.651.748,3.218,3.218,0,0,1,.107,3.284,3.283,3.283,0,0,1-2.423,1.676A3.339,3.339,0,0,1,23.053,26.312ZM11.393,14.03l7.263,8.345.008.012a.324.324,0,0,0,.044.055l.018.016.011.009,2.132,2.449q.077.091.159.172a2.85,2.85,0,0,0,2.027.843,2.956,2.956,0,0,0,.4-.028A2.905,2.905,0,0,0,25.6,24.418a2.833,2.833,0,0,0-.095-2.891,3.03,3.03,0,0,0-.58-.666l-2.41-2.1-.014-.021a.326.326,0,0,0-.041-.05.32.32,0,0,0-.087-.061l-.023-.011-8.3-7.242.138-.144a1.341,1.341,0,0,0-.393-2.139l-.244-.116.887-.887.106.028a1.868,1.868,0,0,0,.48.063,1.854,1.854,0,0,0,1.311-3.166L11.995.675a1.855,1.855,0,0,0-2.623,0,1.863,1.863,0,0,0-.479,1.791l.028.106L2.592,8.9l-.106-.028a1.871,1.871,0,0,0-.48-.063A1.855,1.855,0,0,0,.694,11.976l4.339,4.339a1.857,1.857,0,0,0,2.623,0,1.863,1.863,0,0,0,.479-1.791l-.028-.106.885-.885.116.243a1.344,1.344,0,0,0,2.14.393ZM23.056,25.289a2.216,2.216,0,0,1-1.576-.655c-.043-.043-.084-.088-.123-.134l0,0-1.977-2.271,2.859-2.859,2.272,1.982a2.393,2.393,0,0,1,.459.527A2.214,2.214,0,0,1,25.04,24.1a2.269,2.269,0,0,1-1.671,1.163A2.293,2.293,0,0,1,23.056,25.289ZM19.9,22.243l1.751,2.012c.032.038.066.075.1.11a1.838,1.838,0,0,0,1.307.544,1.912,1.912,0,0,0,.261-.018,1.891,1.891,0,0,0,1.391-.971,1.824,1.824,0,0,0-.061-1.837,2.013,2.013,0,0,0-.385-.444l-.009-.008-2-1.743Zm-.943-.5-.924-1.061,2.66-2.66,1.06.925Zm-.4-1.043.422.485,2.219-2.219-.485-.423Zm-.943-.5-5.764-6.622,1.746-1.746,6.615,5.77Zm-5.243-6.6,5.262,6.046,2.021-2.021-6.04-5.268ZM6.345,16.215a1.2,1.2,0,0,1-.858-.355L1.148,11.522A1.213,1.213,0,0,1,2.863,9.806L7.2,14.145a1.212,1.212,0,0,1-.858,2.07ZM2.006,9.832a.832.832,0,0,0-.588,1.421l4.339,4.339a.832.832,0,0,0,1.177-1.177L2.594,10.075A.826.826,0,0,0,2.006,9.832ZM10.322,13.9a.7.7,0,0,1-.5-1.19L12.724,9.8a.7.7,0,0,1,.987,1l-2.892,2.892A.7.7,0,0,1,10.322,13.9Zm2.893-3.915a.318.318,0,0,0-.223.09l-2.9,2.9a.314.314,0,0,0-.088.22.321.321,0,0,0,.548.227l2.892-2.892a.32.32,0,0,0-.227-.547ZM7.791,13.826,3.183,9.218,9.237,3.163l4.608,4.608L9.373,12.243l-.012.013-.005.005ZM3.721,9.218l4.07,4.07,1.293-1.293.021-.021,2.89-2.89.016-.015,1.3-1.3L9.237,3.7Zm11.3-1.68a1.2,1.2,0,0,1-.858-.355L9.826,2.845a1.213,1.213,0,1,1,1.715-1.715L15.88,5.468a1.213,1.213,0,0,1-.858,2.07ZM10.683,1.154a.832.832,0,0,0-.588,1.421l4.339,4.339A.832.832,0,1,0,15.61,5.737L11.272,1.4A.827.827,0,0,0,10.683,1.154Z",
    transform: "translate(0.229 0.249)",
    fill: "#00641f"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10711",
    "data-name": "Group 10711",
    transform: "translate(755 728)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Renew_-_Flaticon-2_1_",
    "data-name": "Search results for Renew - Flaticon-2 (1)",
    transform: "translate(156 466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10490",
    "data-name": "Group 10490",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10489",
    "data-name": "Group 10489"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10488",
    "data-name": "Group 10488"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10051",
    "data-name": "Path 10051",
    d: "M133.567,247.467a1.683,1.683,0,0,0-1.683,1.683,47.113,47.113,0,0,1-83.207,30.3h9.14a1.683,1.683,0,1,0,0-3.367H44.35a1.683,1.683,0,0,0-1.683,1.683v13.467a1.683,1.683,0,0,0,3.367,0v-9.695A50.48,50.48,0,0,0,135.25,249.15,1.683,1.683,0,0,0,133.567,247.467Z",
    transform: "translate(-34.25 -198.65)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10052",
    "data-name": "Path 10052",
    d: "M50.5,3.367A47.3,47.3,0,0,1,86.573,20.2h-9.14a1.683,1.683,0,0,0,0,3.367H90.9a1.683,1.683,0,0,0,1.683-1.683V8.417a1.683,1.683,0,0,0-3.367,0v9.695A50.48,50.48,0,0,0,0,50.5a1.683,1.683,0,0,0,3.367,0A47.186,47.186,0,0,1,50.5,3.367Z",
    fill: "#00641f"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReRegister);
export default __webpack_public_path__ + "static/media/reRegister.5d8a243e6b971d44312a3ee992fa2813.svg";
export { ForwardRef as ReactComponent };